import { TemplateConfig } from '../types';

export const exPartnerReconciliationConfig: TemplateConfig = {
  id: 'ex-partner-reconciliation',
  name: '前任复合判断',
  description: '从多角度分析复合的可能性',
  cardCount: 9,
  
  fieldDefaults: {
    title: '前任复合判断',
    customerQuestion: '从多角度分析复合的可能性。',
    cardPlaceholders: [
      '请输入第 1 列第 1 张牌',
      '请输入第 2 列第 1 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 4 列第 2 张牌',
      '请输入第 5 列第 2 张牌',
      '请输入第 5 列第 1 张牌',
      '请输入第 4 列第 1 张牌',
      '请输入第 2 列第 2 张牌',
      '请输入第 1 列第 2 张牌'
    ],
    cardInfos: [
      '我和对方之前的感情',
      '分手后我的状态',
      '分手后对方的状态',
      '我对复合的想法',
      '对方对复合的想法',
      '我和对方之间的阻碍',
      '什么可以帮助我和对方之间的关系',
      '我不知道的事情',
      '最后的结局'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#eb2f96',
    backgroundColor: '#fff0f6',
    icon: '💕'
  }
};